"use strict";

document.addEventListener("DOMContentLoaded", function () {
  var CheckLocalizationURLs = function () {
    if (langCode == '') return;
    var $links = $('a').not('[href="#"]');
    $links.each(function () {
      var $this = $(this);
      var url = $this.prop('href');
      if (url.indexOf(location.origin) > -1 && url.indexOf(langCode) == -1) {
        var newURL = new URL(this.href);
        $this.addClass('lang-updated').prop('href', newURL.origin + '/' + langCode + newURL.pathname);
      }
    });
  }();
  var LazyLoading = function () {
    var instance = new LazyLoad();
    function lazyBGImages() {
      var $bgImages = document.querySelectorAll('[data-bg]:not(.lazy)');
      if ($bgImages.length) {
        $bgImages.each(function () {
          $(this).addClass('lazy');
        });
      }
      instance.update();
    }
    function update() {
      lazyBGImages();
    }
    lazyBGImages();
    function refresh() {
      instance.update();
    }
    return {
      update: update,
      refresh: refresh
    };
  }();
  var Cookie = function () {
    /**
     * get cookie value
     * @param   {String} strName - cookie name
     * @returns {String}         - cookie value
     */
    var get = function get(strName) {
      // seperate cookies into array
      var arrCookies = decodeURIComponent(document.cookie).split("; ");
      // initiate cookie value return
      var strCookieValue;
      // remove whitespace
      strName = strName.trim();

      // cycle through cookies
      arrCookies.forEach(function (strCookie) {
        // find cookie and return value
        if (strCookie.indexOf(strName + "=") === 0) {
          strCookieValue = strCookie.split('=')[1];
        }
      });

      // if cookie value is undefined
      if (!strCookieValue) console.warn("Cookie '" + strName + "' does not exist");
      // return cookie value
      return strCookieValue;
    };
    /**
     * Set cookies
     * @param {String} strName        - cookie name
     * @param {String} strValue       - cookie value
     * @param {Number} [intExpInDays] - days until cookie expires
     * @param {String} [strPath]      - path where cookie is accessible
     */
    var set = function set(strName, strValue, intExpInDays, strPath) {
      var strExpires = "";
      /* if strPath is undefined
       * default to domain root */
      strPath = strPath || "/";

      // if intExpInDays is defined
      if (intExpInDays) {
        var objExpireDate = new Date();
        // set time to expiration date
        objExpireDate.setTime(objExpireDate.getTime() + intExpInDays * 24 * 60 * 60 * 1000);
        // format to cookie param
        strExpires = "expires=" + objExpireDate.toUTCString() + ";";
      }
      // set cookie
      document.cookie = strName + "=" + strValue + ";" + strExpires + "path=" + strPath;
    };

    /**
     * remove cookie
     * @param {String} strName - cookie name
     */
    var remove = function remove(strName) {
      // if cookie exists - set expiration to day before
      if (get(strName) !== undefined) set(strName, '_', -1);
    };
    return {
      get: get,
      set: set,
      delete: remove
    };
  }();
  var StickToHeader = function () {
    function init() {
      var $el = $('.stick-to-header');
      if (!$el.length) {
        return false;
      }
      $el.css('top', $('.gheader__main').innerHeight());
    }
    init();
    return {
      refresh: init
    };
  }();
  var AdjustToHeader = function () {
    var $el = $('.adjust-to-header');
    if (!$el.length) {
      return false;
    }
    var wHeight = $(window).height();
    $el.css('max-height', wHeight - $('.gheader__main').innerHeight());
  }();
  var urlParams = function (strParam) {
    var objParams = {};
    function init() {
      objParams = {};
      var arrURLParams = window.location.search.replace('?', '').split('&');
      arrURLParams.map(function (val) {
        var arrPair = val.split('=');
        objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
      });
    }
    init();
    return {
      get: function get(strParam) {
        return objParams[strParam];
      },
      pull: init
    };
  }();
  var SmoothScroll = function () {
    var $anchorLinks = $('a[href^="#"]').not('a[href="#"]');
    var $jsScrollTo = $('.js-scroll-to');
    $('a[href="#"]').click(function (e) {
      e.preventDefault();
      return;
    });
    function goTo(target) {
      if (target === "" || !$(target).length) {
        return;
      }
      var scrollPos = typeof target === 'number' ? target : $(target).offset().top;
      if (window.innerWidth >= 720) {
        scrollPos -= $('header').outerHeight();
      } else {
        scrollPos -= $('header').outerHeight() * 2;
      }
      $('html, body').stop().animate({
        'scrollTop': scrollPos - 32
      }, 1200, 'swing', function () {
        if (typeof target === 'string') {
          if (window.location.hash) {
            // window.location.hash = target;
          }
        }
      });
    }
    if (window.location.hash) {
      setTimeout(function () {
        goTo(window.location.hash);
      }, 500);
    }
    if ($anchorLinks.length) {
      $anchorLinks.on('click', function (e) {
        if (!$("#" + this.hash.replace('#', '')).length) {
          return;
        }
        e.preventDefault();
        goTo(this.hash);
      });
    }
    if ($jsScrollTo.length) {
      $jsScrollTo.on('click', function (e) {
        e.preventDefault();
        goTo('#' + $(this).data('scrollTo'));
      });
    }
    return {
      to: goTo
    };
  }();
  var siteOverlay = function () {
    var $overlay = $('.js-site-overlay');
    function close() {
      $overlay.removeClass('active');
      $('body').removeClass('overlay-open');
      header.closeMegamenus();
    }
    function open() {
      $overlay.addClass('active');
      $('body').addClass('overlay-open');
    }
    $overlay.click(function () {
      close();
    });
    return {
      open: open,
      close: close
    };
  }();

  //Global function to toggle simple accordions
  var Accordions = function () {
    var $accordions = $('.accordion');
    if (!$accordions.length) {
      return;
    }
    $accordions.each(function () {
      if ($(this).hasClass('active')) {
        $(this).find('.accordion__content').show();
      }
    });
    $accordions.find('.accordion__trigger').click(function (e) {
      var $this = $(this);
      var $accordion = $this.parent();
      var $content = $accordion.find('.accordion__content');
      var $siblings = $accordion.siblings();
      if ($accordion.hasClass('active')) {
        $accordion.removeClass('active');
        $content.slideUp('fast');
      } else {
        $accordion.addClass('active');
        $siblings.removeClass('active').find('.accordion__content').slideUp('fast');
        $content.slideDown('fast');
      }
    });
  }();

  //Global function top open / close lightboxes
  var PDMLightbox = function () {
    //Lightbox reset - This lightbox is empty and present on all pages
    var $lightbox = $('.pdm-lightbox--reset');

    //it's content can be filled from various sources
    //after close, the content is wiped
    var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');
    $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {
      e.preventDefault();
      var iframe = $(this).data('lightbox-iframe');
      if (iframe) {
        var replacement = '';
        var youtubePattern = /^(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=))([\w-]{11})(?:\S+)?$/g;
        var vimeoPattern = /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?(?:vimeo\.com\/(?:channels\/\w+\/)?|(?:(?:www|player)\.)?vimeo\.com\/(?:showcase\/\w+\/)?video\/)(\d+)(?:\S+)?$/g;
        if (youtubePattern.test(iframe)) {
          classes += ' youtube-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://www.youtube.com/embed/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(youtubePattern, replacement);
          console.log(iframe);
        }
        if (vimeoPattern.test(iframe)) {
          classes += ' vimeo-vid';
          replacement = '<div class="spacer"><iframe width="560" height="315" frameborder="0" allowfullscreen src="https://player.vimeo.com/video/$1?rel=0&autoplay=1&modestbranding=1&iv_load_policy=3" /></div>';
          iframe = iframe.replace(vimeoPattern, replacement);
        }
        $lightbox_content.html('<div class="video-embed">' + iframe + '</div>');
      } else {
        var content;
        if ($(this).data('lightbox-content')) {
          content = $(this).data('lightbox-content');
        } else if ($(this).data('lightbox-target')) {
          var target = $(this).data('lightbox-target');
          content = $('#' + target).html();
        } else {
          content = $(this).next('.lightbox-content').html();
        }
        $lightbox_content.html(content);
      }
      var classes = $(this).data('lightbox-classes');
      $lightbox.addClass('active').addClass(classes);
    });
    function closeModal($lightbox) {
      $lightbox.removeClass('active');
      $('body').removeClass('no-scroll');
      //wait before removing classes till lightbox closses
      if ($lightbox.hasClass('pdm-lightbox--reset')) {
        setTimeout(function () {
          $lightbox.find('.pdm-lightbox__content').empty();
          $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
        }, 750);
      }
    }
    function openModal($lightbox) {
      $lightbox.addClass('active');
      $('body').addClass('no-scroll');
    }
    function updateModal($lightbox, $content) {
      $lightbox.find('.pdm-lightbox__content').html($content);
    }
    $('.pdm-lightbox').on('click', function (e) {
      if (e.target == this) {
        closeModal($(this));
      }
    });
    $('.pdm-lightbox__close').click(function (e) {
      e.stopPropagation();
      closeModal($(this).closest('.pdm-lightbox'));
    });
    return {
      close: closeModal,
      open: openModal,
      update: updateModal
    };
  }();
  function KlaviyoSubscribe(listID, email, phone, source, $form) {
    $.ajax({
      type: "POST",
      url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      data: {
        g: listID,
        email: email,
        phone_number: phone,
        sms_consent: true,
        $fields: "$source",
        $source: source
      },
      contentType: "application/x-www-form-urlencoded",
      error: function error(err) {
        console.log("Could not connect to Klaviyo.");
        console.log(err);
      },
      success: function success(data) {
        console.log('success');
        console.log(data);
        $form.after('<p>Thank You For Subscribing!</p>');
        $form.hide();
      }
    });
  }
  var header = function () {
    var $menubtn = $('.menu-burger');
    var $mobMenu = $('.gheader__mobile-menu');
    var $mobDropdowns = $('.gheader__mobile-menu .parent-link.haslinks > a');
    var $mobSubcollections = $('.gheader__mobile-menu .child-link.has-subcollections > a');
    $menubtn.click(function () {
      $menubtn.toggleClass('active');
      $mobMenu.toggleClass('active');
    });
    $mobDropdowns.click(function (e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.next().slideUp();
      } else {
        $mobDropdowns.removeClass('active');
        $mobDropdowns.next().slideUp();
        $this.toggleClass('active');
        $this.next().slideDown();
      }
    });
    $mobSubcollections.click(function (e) {
      e.preventDefault();
      var $this = $(this);
      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $this.next().slideUp();
      } else {
        $mobSubcollections.removeClass('active');
        $mobSubcollections.next().slideUp();
        $this.toggleClass('active');
        $this.next().slideDown();
      }
    });
    $('.gheader__mobile-menu .swiper').each(function () {
      var $this = $(this);
      var swiper = new Swiper($this[0], {
        slidesPerView: 1.5,
        loop: false,
        spaceBetween: 16,
        navigation: {
          nextEl: $this.find('.swiper-button-next')[0],
          prevEl: $this.find('.swiper-button-prev')[0]
        },
        breakpoints: {
          400: {
            slidesPerView: 2.5
          }
        },
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    });

    // $mobMenu.find('.search-icon').click(function(){
    // 	$mobMenu.find('.search-bar').slideToggle();
    // });

    // var $icons = $('.gheader__icons');

    // $icons.find('.search-icon,.close-search').click(function(){
    // 	$icons.find('.search-bar').toggleClass('active');
    // });

    var $megamenuTrigger = $('.gheader__menu [data-menu]');
    var $megamenus = $('.mega-menu');
    var $megamenusWrap = $('.gheader__mega-menus');
    var $defaultCollections = $('.default-collections');
    var $selectedCollections = $('.selected-collections');
    function closeMegamenus() {
      $megamenusWrap.removeClass('active');
      $megamenus.removeClass('active');
      $megamenuTrigger.removeClass('active');
    }
    $megamenuTrigger.click(function (e) {
      e.preventDefault();
      siteOverlay.open();
      $defaultCollections.show();
      $selectedCollections.hide();
      var $this = $(this);
      var menu = $this.data('menu');
      var $menu = $megamenus.filter('[data-menu="' + menu + '"]');
      if ($menu.hasClass('active')) {
        closeMegamenus();
        siteOverlay.close();
      } else {
        $this.addClass('active');
        $megamenusWrap.addClass('active');
        $megamenuTrigger.removeClass('active');
        $this.addClass('active');
        // $('body').addClass('blur');
        var timeout = 0;
        if ($megamenus.filter('.active').length) {
          timeout = 250;
        }
        $megamenus.removeClass('active');
        setTimeout(function () {
          $menu.addClass('active');
        }, timeout);
      }
    });
    $megamenusWrap.click(function (e) {
      if (e.target == this) {
        closeMegamenus();
      }
    });
    $('.mega-menu .has-subcollections a').on('mouseenter', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $megamenu = $this.closest('.mega-menu');
      var $selectedCollection = $megamenu.find('.selected-collections');
      $megamenu.find('.has-subcollections a').removeClass('active');
      $this.addClass('active');
      var $subs = $this.parent().find('.swiper').clone();
      $selectedCollection.empty().append($subs);
      LazyLoading.refresh();
      var $slider = $selectedCollection.find('.swiper');
      var swiper = new Swiper($slider[0], {
        slidesPerView: 3,
        loop: false,
        spaceBetween: 16,
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        },
        scrollbar: {
          el: $slider.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
      $defaultCollections.hide();
      $selectedCollection.show();
    });
    return {
      closeMegamenus: closeMegamenus
    };
  }();
  var footerSubscribe = function () {
    $('.gfooter form').submit(function (e) {
      e.preventDefault();
      var $this = $(this);
      var $email = $this.find('[name="email"]');
      var $phone = $this.find('[name="phone"]');
      if ($email.val() != '' && $phone.val() != '') {
        KlaviyoSubscribe('XqQFkZ', $email.val(), $phone.val(), 'Website Footer', $this);
      }
    });
  }();
  var QtyInput = function () {
    var $qtyInputs = $('.qty-input');
    if (!$qtyInputs.length) {
      return;
    }
    var $inputs = $qtyInputs.find('.product-qty');
    var $countBtn = $qtyInputs.find('.qty-count');
    $inputs.each(function () {
      var min = 1;
      if ($(this).data('min') != undefined) {
        min = parseInt($(this).data('min'));
      }
      if ($(this).val() > min) {
        $(this).siblings('.qty-count--minus').attr('disabled', false);
      } else {}
    });
    $('body').on('change', '.qty-input .product-qty', function () {
      var $this = $(this);
      var $minusBtn = $this.siblings('.qty-count--minus');
      var qty = parseInt($this.val());
      var min = 1;
      if ($this.data('min') != undefined) {
        min = parseInt($this.data('min'));
      }
      if (isNaN(qty) || qty <= min) {
        $this.val(min);
        $minusBtn.attr('disabled', true);
      } else {
        $minusBtn.attr('disabled', false);
        $this.val(qty);
      }
    });
    $('body').on('click', '.qty-count', function () {
      var operator = this.dataset.action;
      var $this = $(this);
      var $input = $this.siblings('.product-qty');
      var qty = parseInt($input.val());
      var min = 1;
      if ($input.data('min') != undefined) {
        min = parseInt($input.data('min'));
      }
      if (operator == 'add') {
        qty += 1;
        if (qty == min + 1) {
          $this.siblings('.qty-count--minus').attr('disabled', false);
        }
      } else {
        qty = qty <= min ? min : qty -= 1;
        if (qty == min) {
          $this.attr('disabled', true);
        }
      }
      $input.val(qty).trigger('change');
    });
  }();
  var productGallery = function () {
    var $slider = $('.product-gallery .swiper');
    if (!$slider.length) {
      return;
    }

    // var swiper = new Swiper($slider[0],{
    // 	slidesPerView: 1,
    // 	loop: true,
    // 	spaceBetween:0,
    // 	scrollbar: {
    // 		el: $slider.find('.swiper-scrollbar')[0],
    // 		draggable:true,
    // 	},
    // 	navigation: {
    // 		nextEl: $slider.find('.swiper-button-next')[0],
    // 		prevEl: $slider.find('.swiper-button-prev')[0],
    // 	}
    // });

    if ($(window).width() < 767) {
      var swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        draggable: false,
        allowTouchMove: false,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        }
      });
    } else {
      var swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        }
      });
    }
  }();
  var shopCart = function (updates) {
    var $body = $('body');
    var $popcart = $('.pop-cart');
    var $cartItemContainer = $('.the-cart__items');
    var $cartEmptyContainer = $popcart.find('.pop-cart__empty');
    var $cartContainer = $popcart.find('.pop-cart__container');
    function open() {
      $body.addClass('cart-open');
      $popcart.addClass('active');
    }
    function close() {
      $body.removeClass('cart-open');
      $popcart.removeClass('active');
    }
    function refresh() {
      $.ajax({
        url: '/cart.js',
        dataType: 'json',
        type: "get",
        success: function success(res) {
          console.log(res);
          var items = res.items;
          $cartItemContainer.empty();
          $.each(items, function (i, item) {
            var image = item.featured_image.url;
            var skeleton = $cartItemContainer.parent().find('.cart-card--skeleton').clone().removeClass('cart-card--skeleton')[0].outerHTML;
            skeleton = skeleton.replaceAll('||item.url||', item.url);
            skeleton = skeleton.replaceAll('||item.id||', item.variant_id);
            skeleton = skeleton.replaceAll('||item.title||', item.product_title);
            skeleton = skeleton.replaceAll('||item.price||', Shopify.formatMoney(item.price, '${{amount_no_decimals}}').replace('$', currencySymbol + ' '));
            skeleton = skeleton.replaceAll('||item.image||', image);
            skeleton = skeleton.replaceAll('||item.index||', i + 1);
            var qFound = false;
            var quantities = '';
            for (i = 1; i < 6; i++) {
              if (i == item.quantity) {
                qFound = true;
                quantities += '<option selected value="' + i + '">' + i + '</option>';
              } else {
                quantities += '<option value="' + i + '">' + i + '</option>';
              }
            }
            if (qFound == false) {
              quantities += '<option selected value="' + item.quantity + '">' + item.quantity + '</option>';
            }
            skeleton = skeleton.replaceAll('||item.quantities||', quantities);
            var $variants = '';
            if (!item.product_has_only_default_variant) {
              $variants += '<ul class="cart-card__meta">';
              $.each(item.options_with_values, function (i, option) {
                $variants = $variants + '<li>' + option.name + ': ' + option.value + '</li>';
              });
              $variants = $variants + '</ul>';
            }
            skeleton = skeleton.replaceAll('||item.variants||', $variants);
            var $meta = '';
            if (item.properties != null) {
              $meta += '<ul class="cart-card__meta">';
              $.each(item.properties, function (key, value) {
                if (key === "_engravingFreeFee") return;
                $meta = $meta + '<li>' + key + ': ' + value + '</li>';
              });
              $meta = $meta + '</ul>';
            }
            skeleton = skeleton.replaceAll('||item.meta||', $meta);
            $cartItemContainer.append(skeleton);
          });

          //now that the items are loaded get the images again
          LazyLoading.refresh();
          //if there is items toggle a class to show or hide no item state
          if (res.item_count == 0) {
            $cartContainer.removeClass('has-items');
          } else {
            $cartContainer.addClass('has-items');
          }
          //update subtotal in all places needed
          $('.js-cart-subtotal').text(Shopify.formatMoney(res.total_price, '${{amount_no_decimals}}').replace('$', currencySymbol + ' '));
          //update cart count on all places needed
          $('.js-cart-count').text(res.item_count);
          //extras
          $('.quick-view-popup').removeClass('active');
          open();
        },
        error: function error(res) {
          console.log(res);
          open();
        }
      });
    }
    function remove(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/update.js',
        type: "post",
        data: {
          updates: updates
        },
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function update(updates) {
      // console.log(updates);
      $.ajax({
        url: window.Shopify.routes.root + 'cart/change.js',
        type: "post",
        data: updates,
        success: function success(res) {
          console.log('cart updated');
          refresh();
          // console.log(res);
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    function add($form) {
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: "post",
        data: $form.serialize(),
        success: function success(res) {
          refresh();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    return {
      add: add,
      open: open,
      close: close,
      refresh: refresh,
      remove: remove,
      update: update
    };
  }();
  var Cart = function () {
    var $cart = $('.pop-cart');
    var $cartIcon = $('.menu-icon--cart');
    var $cartClose = $('.pop-cart__close');
    $cartClose.click(function () {
      shopCart.close();
    });
    $cart.on('click', function (e) {
      if (e.target == this) {
        shopCart.close();
      }
    });
    $cartIcon.click(function (e) {
      e.preventDefault();
      shopCart.open();
    });
    $('body').on('click', '.ajax-remove-cart-item', function (e) {
      e.preventDefault();
      var $card = $(this).closest('.cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item[id] = 0;
      shopCart.remove(item);
    });
    $('body').on('change', '[name="updates[]"]', function (e) {
      e.preventDefault();
      var $this = $(this);
      var $card = $this.closest('.cart-card');
      var id = parseInt($card.data('id'));
      var item = {};
      item.id = id;
      item.quantity = $this.val();
      shopCart.update(item);
    });
    var openCartParam = urlParams.get('cart');
    if (openCartParam == 'open') {
      shopCart.open();
    }
  }();
  var AddToCartForm = function () {
    $('body').on('submit', 'form[action="/cart/add"]', function (e) {
      e.preventDefault();
      var $this = $(this);

      // var item = {};

      // item.id = $this.find('[name="id"]').val();
      // item.quantity = 1;

      // if( $this.find('[name="quantity"]') ){
      // 	item.quantity = $this.find('[name="quantity"]').val();
      // }

      // var items = [item];

      shopCart.add($this);
    });
  }();
  var StickyATC = function () {
    var $section = $('.sticky-atc');
    if (!$section.length) {
      return;
    }
    var $atc = $section.find('.js-product__atc');
    function update(product) {
      var $title = $section.find('.js-product__name');
      var $price = $section.find('.js-product__price');
      var $variant = $section.find('.js-product__variant');
      var $image = $section.find('.js-product__image');
      $atc.attr('disabled', !product.available);
      $atc.text(product.available ? 'Add to Cart' : 'Out of Stock');
      $price.text(Shopify.formatMoney(product.price, '${{amount_no_decimals}}').replace('$', window.currencySymbol + ' '));
      var pname = product.name.split(' -');
      $title.text(pname[0]);
      $variant.text(pname[1]);
      $image.attr('src', product.featured_image.src).attr('srcset', product.featured_image.src);
    }
    $atc.on('click', function () {
      $('.main-atc-form').find('[type="submit"]').trigger('click');
    });
    var observer = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) {
        $section.addClass('active');
      } else {
        $section.removeClass('active');
      }
    });
    observer.observe($(".mproduct")[0]);
    return {
      update: update
    };
  }();
  var productVariants = function () {
    // Function to handle non-existent product combinations.
    function handleNonExistent($form) {
      /*
      	$atc.attr('disabled',true);
        	var found2 = false;
      	var found3 = false;
      	var message = options[0] + ' / ';
        	$.each(variants, function(i,variant){
      		if( options.length >= 2 ){
      			if( variant.option1 == options[0] && variant.option2 == options[1] ){
      				found2 = true;
      			}
      		}
      		if( options.length == 3 ){
      			if( variant.option1 == options[0] && variant.option3 == options[2] ){
      				found3 = true;
      			}
      		}
      	});
        	if( found2 ){
      		message += options[1] + ' Is Not Available In ' + options[2];
      	}else{
      		message += options[2] + ' Is Not Available In ' + options[1];
      	}
        	window.history.replaceState(null, '', window.location.pathname);
        	$atc.text(message);
        	//since technically the only way to get a non existend product
      	//if by selecting a parent variant type that is available
      	//lets find the closest one and select it ( or use the code above this message instead )
      	*/

      // Code to find the closest available variant and select it.

      var variants = window.productInfo[$form.data('handle')];
      var $groups = $form.find('.pdp-atc__group');
      var $firstSelect = $groups.eq(0).find('.pdp-atc__group__select select');
      var firstOption = $firstSelect.val();
      var replaceVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == firstOption) {
          replaceVariant = variant;
          // console.log(variant);
          if (variant.available) {
            return false;
          }
        }
      });
      if (replaceVariant) {
        var index = 0;
        $groups.each(function () {
          index++;
          var optionSelector = 'option' + index;
          $(this).find('input[value="' + replaceVariant[optionSelector] + '"]').trigger('click');
        });
      }
    }

    // Function to handle selection of product variant.
    function selectVariant($form) {
      // Code to handle selection of a variant.
      // It updates the main select value, replaces URL, enables/disables add to cart button,
      var variants = window.productInfo[$form.data('handle')];
      var $atc = $form.find('.pdp-atc__btn');
      var atcText = $atc.data('text');
      var $groups = $form.find('.pdp-atc__group');
      var $mainSelect = $form.find('.pdp-atc__select select');
      var options = [];
      $groups.each(function () {
        var $this = $(this);
        var val = $this.find('.pdp-atc__group__select select').val();
        options.push(val);
        $this.find('.selected-option').text(val);
      });
      var selectedVariant = false;
      $.each(variants, function (i, variant) {
        if (variant.option1 == options[0] && variant.option2 == options[1] && variant.option3 == options[2]) {
          selectedVariant = variant;
          return false;
        }
      });
      if (selectedVariant) {
        $mainSelect.val(selectedVariant.id);
        if ($form.hasClass('main-atc-form')) {
          window.history.replaceState(null, null, '?variant=' + selectedVariant.id);
        }
        if (selectedVariant.available) {
          $atc.attr('disabled', false);
          $atc.text(atcText);
        } else {
          $atc.attr('disabled', true);
          $atc.text('Sold Out');
        }

        //do other theme specific things after a variant is selected
        //change image slide, update price etc...
        //selectedVariant is a object including all of its information that you may need
        var $parent = $form.closest('.js-product-container');
        var $price = $parent.find('.js-product-price');
        $price.text(Shopify.formatMoney(selectedVariant.price, '${{amount_no_decimals}}').replace('$', currencySymbol + ' '));
        if (selectedVariant.featured_image) {
          var $slider = $parent.find('.product-gallery .swiper');
          var image = selectedVariant.featured_image.src;
          // var newSlide = $slider.find('[data-master="'+image+'"]');
          var newSlide = $slider.find('[data-master="' + image + '"]').data('index');
          var swiper = $slider[0].swiper;
          swiper.slideTo(newSlide, 0);
        }
        StickyATC.update(selectedVariant);
        var $oosNotification = $parent.find('.oos-options');
        var $oosNotificationID = $oosNotification.find('[name="0-2/product_id"]');
        if (selectedVariant.available) {
          $parent.removeClass('oos-product');
          $oosNotification.removeClass('active');
        } else {
          $parent.addClass('oos-product');
          $oosNotification.addClass('active');
          $oosNotificationID.val(selectedVariant.id);
        }
      } else {
        //no mathing variant was found edge case - add descriptive text to atc button and maybe output a message?
        handleNonExistent($form);
      }
    }

    // Shopify logic for linking option selectors.
    function updateOptionsInSelector(selectorIndex, $form, allOptionsMap, inStockOptionsMap) {
      // Code to update the available options in a selector based on selected values of other selectors.
      var key, $selector;
      switch (selectorIndex) {
        case 0:
          key = 'root';
          $selector = $form.find('.pdp-atc__group__select:eq(0) select');
          break;
        case 1:
          key = $form.find('.pdp-atc__group__select:eq(0) select').val();
          $selector = $form.find('.pdp-atc__group__select:eq(1) select');
          break;
        case 2:
          key = $form.find('.pdp-atc__group__select:eq(0) select').val();
          key += ' / ' + $form.find('.pdp-atc__group__select:eq(1) select').val();
          $selector = $form.find('.pdp-atc__group__select:eq(2) select');
      }
      var availableOptions = allOptionsMap[key];
      var inStockOption = inStockOptionsMap[key];
      $selector.find('option').each(function (i, option) {
        var $this = $(this);
        var value = $this.val();
        var $radio = $this.closest('.pdp-atc__group').find('input[type="radio"][value="' + value + '"]');
        if (availableOptions && availableOptions.includes(value)) {
          $this.attr('disabled', false);
          $radio.attr('disabled', false);
          if (inStockOption && inStockOption.includes(value)) {
            $this.text($this.val());
            $this.removeClass('oos');
            $radio.removeClass('oos');
          } else {
            $this.text($this.val() + ' (Soldout)');
            $this.addClass('oos');
            $radio.addClass('oos');
          }
        } else {
          $this.text($this.val());
          $this.attr('disabled', true);
          $radio.attr('disabled', true);
        }
      });
    }

    // Shopify logic for linking option selectors.
    function linkOptionSelectors($form) {
      var variants = window.productInfo[$form.data('handle')];

      // Shopify related logic.
      var Shopify = Shopify || {};
      // Required functionality from deprecated options_selection.js.
      // Code to define utility functions used later in Shopify logic.

      // Required functionality from depricated options_selection.js
      Shopify.arrayIncludes = function (e, t) {
        // Code to update the available options in a selector based on selected values of other selectors.
        for (var n = 0; n < e.length; n++) if (e[n] == t) return !0;
        return !1;
      }, Shopify.uniq = function (e) {
        for (var t = [], n = 0; n < e.length; n++) Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
        return t;
      };
      var allOptionsMap = {};
      var inStockOptionsMap = {};
      // Code to build mapping between product options and variants.

      // Building our mapping object.
      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];
        var key;
        if (variant) {
          // Gathering values for the 1st drop-down.
          allOptionsMap.root = allOptionsMap.root || [];
          allOptionsMap.root.push(variant.option1);
          allOptionsMap.root = Shopify.uniq(allOptionsMap.root);
          // Gathering values for the 2nd drop-down.
          if (variant.options.length > 1) {
            key = variant.option1;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option2);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
          // Gathering values for the 3rd drop-down.
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            allOptionsMap[key] = allOptionsMap[key] || [];
            allOptionsMap[key].push(variant.option3);
            allOptionsMap[key] = Shopify.uniq(allOptionsMap[key]);
          }
        }
        if (variant.available) {
          // Gathering values for the 1st drop-down.
          inStockOptionsMap.root = inStockOptionsMap.root || [];
          inStockOptionsMap.root.push(variant.option1);
          inStockOptionsMap.root = Shopify.uniq(inStockOptionsMap.root);
          // Gathering values for the 2nd drop-down.
          if (variant.options.length > 1) {
            key = variant.option1;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option2);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
          // Gathering values for the 3rd drop-down.
          if (variant.options.length === 3) {
            key = variant.option1 + ' / ' + variant.option2;
            inStockOptionsMap[key] = inStockOptionsMap[key] || [];
            inStockOptionsMap[key].push(variant.option3);
            inStockOptionsMap[key] = Shopify.uniq(inStockOptionsMap[key]);
          }
        }
      }

      // Update options right away.
      updateOptionsInSelector(0, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length > 1) updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
      if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);

      // When there is an update in the first dropdown.
      $form.find('.pdp-atc__group__select:eq(0) select').change(function () {
        updateOptionsInSelector(1, $form, allOptionsMap, inStockOptionsMap);
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });

      // When there is an update in the second dropdown.
      $form.find('.pdp-atc__group__select:eq(1) select').change(function () {
        if (variants[0].options.length === 3) updateOptionsInSelector(2, $form, allOptionsMap, inStockOptionsMap);
        return true;
      });
    }
    function init($form) {
      //only turned this into a function because of an app that would stop the trigger change from working on the buttons below
      function handleSelectChange($select) {
        // console.log('product form handle select triggered ' + $select.val());
        var $form = $select.closest('form');
        linkOptionSelectors($form);
        selectVariant($form);
      }
      $form.on('change', 'select', function () {
        // console.log('product form select change detected');
        handleSelectChange($(this));
      });

      // Event handler for changing product options via radio buttons.
      $form.on('change', '.pdp-atc__group__buttons input', function () {
        // console.log('product form radio change detected ' + $(this).val());
        // console.log($form)
        // Code to synchronize radio button with corresponding select element.
        var $this = $(this);
        var val = $this.val();
        $this.closest('.pdp-atc__group').find('.pdp-atc__group__select select').val(val);
        handleSelectChange($this.closest('.pdp-atc__group').find('.pdp-atc__group__select select'));
      });
      var $groups = $form.find('.pdp-atc__group');
      var $firstSelect = $groups.eq(0).find('.pdp-atc__group__select select');
      $firstSelect.trigger('change');
    }
    var $forms = $('.pdp-atc');
    $forms.each(function () {
      var $form = $(this);
      init($form);
    });
    return {
      init: init
    };
  }();
  var reserveProduct = function () {
    var $reserveBtn = $('.reserve-btn');
    $reserveBtn.click(function () {
      $('.reserve-popup').addClass('active');
    });
  }();
  var loginPage = function () {
    var $loginToggle = $('.login-toggle');
    if (!$loginToggle.length) {
      return;
    }
    if (window.location.href.indexOf('recover') > -1) {
      $('.reset-tab').show();
      $('.login-tab').hide();
    }
    $loginToggle.click(function () {
      $('.reset-tab').toggle();
      $('.login-tab').toggle();
    });
  }();
  var addressPage = function () {
    $('button.add-address').click(function () {
      $('.add-address-lightbox').addClass('active');
    });
    $('.edit-address').click(function () {
      var target = $(this).data('target');
      $('#lightbox-' + target).addClass('active');
    });
  }();
  var featuredProductCollections = function () {
    var $section = $('.pcollections');
    if (!$section.length) {
      return;
    }
    function initSliders() {
      var $sliders = $('.pcollections__slider');
      $sliders.each(function () {
        var $this = $(this);
        var $slider = new Swiper($this[0], {
          slidesPerView: 1.25,
          spaceBetween: 16,
          breakpoints: {
            500: {
              slidesPerView: 2.25
            },
            960: {
              slidesPerView: 3.25
            }
          },
          scrollbar: {
            el: $this.find('.swiper-scrollbar')[0],
            draggable: true
          }
        });
      });
      var $nav = $('.pcollections__nav button');
      $nav.click(function () {
        var $this = $(this);
        var collection = $this.data('collection');
        console.log(collection);
        $nav.removeClass('active');
        $sliders.removeClass('active');
        $this.addClass('active');
        $sliders.filter('[data-collection="' + collection + '"]').addClass('active');
      });
    }
    if ($section.data('url')) {
      var $parent = $section.closest('.shopify-section');
      var id = $parent.attr('id');
      $.ajax({
        url: $section.data('url'),
        type: "GET",
        success: function success(res) {
          // console.log(res);
          $parent.after(res);
          $parent.remove();
          LazyLoading.update();
          initSliders();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    initSliders();
  }();
  var uspSlider = function () {
    var $sliders = $('.usp-slider .swiper');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $parent = $this.closest('.usp-slider');
      var mobMax = 1;
      var tabMax = 2;
      var max = 4;
      if ($parent.hasClass('usp-slider--condensed')) {
        mobMax = 1;
        tabMax = 2;
        max = 3;
      }
      var $slider = new Swiper($this[0], {
        slidesPerView: mobMax,
        spaceBetween: 0,
        slidesPerGroup: mobMax,
        breakpoints: {
          600: {
            slidesPerGroup: tabMax,
            slidesPerView: tabMax
          },
          960: {
            slidesPerGroup: max,
            slidesPerView: max
          }
        },
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $this.find('.swiper-button-next')[0],
          prevEl: $this.find('.swiper-button-prev')[0]
        }
      });
    });
  }();
  var heroSlider = function () {
    var $sliders = $('.hero .swiper');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var delay = $this.data('delay');
      if (delay == undefined || isNaN(delay)) {
        delay = 5000;
      }
      // console.log(delay);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: delay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      });
    });
  }();
  var imageGallerySlider = function () {
    var $sliders = $('.image-gallery__loop .swiper');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1.5,
        spaceBetween: 16,
        loop: true,
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        },
        breakpoints: {
          500: {
            slidesPerGroup: 1,
            slidesPerView: 2.5
          },
          960: {
            slidesPerGroup: 1,
            slidesPerView: 4
          }
        }
      });
    });
  }();
  var featuredCollections = function () {
    var $sliders = $('.fcollections__loop');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        breakpoints: {
          960: {
            centeredSlides: false,
            slidesPerGroup: 3,
            slidesPerView: 3
          }
        },
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    });
  }();
  var productHighlights = function () {
    var $sliders = $('.prod-highlights__loop');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1.25,
        // centeredSlides: true,
        // loop: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        longSwipes: false,
        //to disabled this feature
        longSwipesMs: 300,
        // setting the time threshold between long and short.
        breakpoints: {
          960: {
            centeredSlides: false,
            slidesPerGroup: 3,
            slidesPerView: 3
          }
        }
      });
    });
    var $readmore = $('.hlight-card .read-more--toggle');
    $readmore.click(function () {
      $(this).closest('.hlight-card').toggleClass('active');
    });
  }();
  var inCartUpsells = function () {
    var $sliders = $('.cart-card__upsells_slider');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1,
        breakpoints: {
          960: {
            slidesPerView: 2.5
          },
          1200: {
            slidesPerView: 3.5
          }
        },
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    });
  }();
  var featProdBanner = function () {
    var $sliders = $('.fproducts-wbanner__products .swiper');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1.25,
        spaceBetween: 16,
        slidesPerGroup: 1,
        breakpoints: {
          960: {
            slidesPerView: 1.75
          },
          1200: {
            slidesPerView: 2.25
          },
          1300: {
            slidesPerView: 2.75
          }
        },
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    });
  }();
  var productCard = function () {
    $('body').on('click', '.product-card__swatches button', function () {
      var $this = $(this);
      if ($this.hasClass('disabled')) {
        return false;
      }
      var price = $this.data('price');
      var image = $this.data('image');
      var $card = $this.parents('.product-card');
      var $swatches = $card.find('.product-card__swatches button');
      var $image = $card.find('.product-card__image .positioner:not(.positioner--hover) img');
      $card.find('.js-product-price').text(price);
      console.log(image);
      $swatches.removeClass('active');
      $this.addClass('active');

      // $image.parent().addClass('variant-active');
      $image.attr('src', image);
      $image.attr('srcset', image);
    });
    function initQuickview() {
      var $slider = $('.prod-qv__images .swiper');
      var $form = $('.prod-qv form');
      var swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        }
      });
      LazyLoading.refresh();
      productVariants.init($form);
    }
    $('body').on('click', '.quick-view-close', function () {
      $('.quick-view-popup').removeClass('active');
      $('body').removeClass('no-scroll');
    });
    $('body').on('click', '.quick-view-trigger', function () {
      var url = $(this).data('url');
      var $lightbox = $('.quick-view-popup');
      var $lightbox_content = $('.quick-view-popup .pdm-lightbox__content');
      $.ajax({
        url: window.Shopify.routes.root + url + '?view=quick-view',
        type: "GET",
        success: function success(res) {
          // console.log(res);
          $lightbox_content.html($(res).find('#product-quickview').html());
          $('body').addClass('no-scroll');
          $lightbox.addClass('active');
          initQuickview();
        },
        error: function error(res) {
          console.log(res);
        }
      });
    });
  }();
  var collectionFacets = function () {
    var $ajaxWrap = $('#ajax-collection');
    if (!$ajaxWrap.length) {
      return;
    }
    var base_url = location.origin + location.pathname;
    var urls = [];
    var responses = [];
    urls.push(base_url);
    responses.push($('#ajax-collection').html());
    function filterCollection(url) {
      if (urls.indexOf(url) > -1) {
        $ajaxWrap.html(responses[urls.indexOf(url)]);
        LazyLoading.refresh();
      } else {
        $.ajax({
          url: url,
          type: "GET",
          beforeSend: function beforeSend() {
            $ajaxWrap.find('.collection-grid').addClass('loading');
          },
          success: function success(res) {
            var ajaxHTML = $(res).find('#ajax-collection').html();
            $ajaxWrap.html(ajaxHTML);
            urls.push(url);
            responses.push(ajaxHTML);
            LazyLoading.update();
            StickToHeader.refresh();
          },
          error: function error(res) {
            console.log(res);
          }
        });
      }
      window.history.replaceState(null, null, url);
    }
    console.log('collection ajax');
    $('body').on('submit', 'form.col-facets', function (e) {
      e.preventDefault();
      var $this = $(this);
      var url = base_url;
      if ($this.serialize()) {
        url = '?' + $this.serialize();
      }
      filterCollection(url);
    });
    $('body').on('click', '.remove-filter', function () {
      var $this = $(this);
      var url = $this.data('remove');
      filterCollection(url);
    });
    $('body').on('change', 'form.col-facets', function () {
      $('.col-facets__submit').click();
    });
    $('body').on('change', '.facet-filters__sort', function () {
      $('[name="sort_by"]').val($(this).val());
      $('.col-facets__submit').click();
    });
    $('body').on('click', '.filter legend', function () {
      var $is_active = $(this).closest('.filter').hasClass('active');
      $('.filter').removeClass('active');
      if (!$is_active) {
        $(this).closest('.filter').addClass('active');
      }
    });
    $('body').on('click', '.show-filters', function () {
      $('form.col-facets').toggleClass('active');
    });
  }();
  var cartUpsells = function () {
    var $slider = $('.pop-cart__upsells');
    if (!$slider.length) {
      return;
    }
    console.log('start');
    var swiper = new Swiper($slider[0], {
      slidesPerView: 1.5,
      spaceBetween: 16,
      breakpoints: {
        400: {
          slidesPerView: 1.75
        },
        600: {
          slidesPerView: 2.1
        }
      },
      scrollbar: {
        el: $slider.find('.swiper-scrollbar')[0],
        draggable: true
      }
    });
  }();
  var compareProducts = function () {
    var $section = $('section.compare');
    if (!$section.length) {
      return;
    }
    var currentHandle = $('.mproduct').data('handle');
    var previous = false;
    if (Cookie.get('last_product')) {
      previous = Cookie.get('last_product');
      if (previous == currentHandle) {
        previous = false;
      } else {
        Cookie.set('last_product', currentHandle, 31);
      }
    } else {
      Cookie.set('last_product', currentHandle, 31);
    }
    var $compare = $section.find('.compare-card__other');
    function compareProducts(handle) {
      $compare.addClass('loading');
      var url;
      if (window.Shopify.routes.root.length > 2) {
        url = window.Shopify.routes.root + '/products/' + handle;
      } else {
        url = '/products/' + handle;
      }
      $.ajax({
        url: url + '?view=compare',
        type: "GET",
        success: function success(res) {
          // console.log(res);
          console.log($(res).find('#compare-other'));
          $compare.html($(res).find('#compare-other').html());
          $compare.removeClass('loading');
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    if (previous) {
      compareProducts(previous);
    } else {
      var handle = $compare.data('default');
      compareProducts(handle);
    }
    $('body').on('change', '.compare select', function () {
      compareProducts($(this).val());
    });
  }();

  // var ImgCardSlider = (function () {
  // 	var $section = $('.imgcards-slider');
  // 	if (!$section.length) { return; }

  // 	var swiperCurrent = new Swiper('.imgcards-slider .swiper--current',{
  // 		slidesPerView: 1,
  // 		effect: 'fade',
  // 		crossfade: true,
  // 	});

  // 	var swiperContent = new Swiper('.imgcards-slider .swiper--slider',{
  // 		slidesPerView: 1.4,
  // 		spaceBetween: 16,
  // 		breakpoints: {
  // 			720: {
  // 				initialSlide: 1,
  // 				navigation: {
  // 					nextEl: '.imgcards-slider .swiper--slider .swiper-button-next',
  // 					prevEl: '.imgcards-slider .swiper--slider .swiper-button-prev',
  // 				  },
  // 			}
  // 		}
  // 	});

  // 	swiperCurrent.controller.control = swiperContent;
  // 	swiperContent.controller.control = swiperCurrent;
  // }());

  var ImgCardSlider = function () {
    var $section = $('.imgcards-slider');
    if (!$section.length) {
      return;
    }
    var swiperCurrent = new Swiper('.imgcards-slider .swiper--current', {
      slidesPerView: 1,
      loop: true,
      loopedSlides: 3,
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      }
    });
    var swiperContent = new Swiper('.imgcards-slider .swiper--slider', {
      slidesPerView: 1.25,
      spaceBetween: 16,
      scrollbar: {
        el: '.imgcards-slider .swiper-scrollbar',
        draggable: true
      },
      navigation: {
        nextEl: '.imgcards-slider .swiper--slider .swiper-button-next',
        prevEl: '.imgcards-slider .swiper--slider .swiper-button-prev'
      },
      breakpoints: {
        420: {
          slidesPerView: 1.75,
          loopedSlides: 2
        },
        960: {
          slidesPerView: 1,
          loopedSlides: 3,
          spaceBetween: 48,
          loop: true
        }
      }
    });
    swiperCurrent.controller.control = swiperContent;
    swiperContent.controller.control = swiperCurrent;
  }();
  var PartnershipsSlider = function () {
    var $section = $('.partnerships-slider');
    if (!$section.length) {
      return;
    }
    var swiper = new Swiper('.partnerships-slider .swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      scrollbar: {
        el: '.partnerships-slider .swiper-scrollbar',
        draggable: true
      },
      navigation: {
        nextEl: '.partnerships-slider .swiper-button-next',
        prevEl: '.partnerships-slider .swiper-button-prev'
      },
      breakpoints: {
        960: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    });
  }();
  var MeetNorainers = function () {
    var $section = $('.other-partners__slider');
    if (!$section.length) {
      return;
    }
    var swiper = new Swiper($section[0], {
      slidesPerView: 1,
      spaceBetween: 16,
      scrollbar: {
        el: $section.find('.swiper-scrollbar'),
        draggable: true
      },
      breakpoints: {
        960: {
          slidesPerView: 3,
          slidesPerGroup: 3
        }
      }
    });
  }();

  // var MeetNorainers = (function(){

  // 	var $section = $('.meet-norqainers');

  // 	if( !$section.length ){ return; }

  // 	function initSliders(){
  // 		var $sliders = $('.meet-norqainers__slider');

  // 		$sliders.each(function(){
  // 			var $this = $(this);
  // 			var $slider = new Swiper($this[0],{
  // 				slidesPerView: 1,
  // 				spaceBetween:16,
  // 				breakpoints: {
  // 					500: {
  // 					  slidesPerView: 2,
  // 					},
  // 					960: {
  // 					  slidesPerView: 3,
  // 					}
  // 				},
  // 				scrollbar:{
  // 					el:$this.find('.swiper-scrollbar')[0],
  // 					draggable:true,
  // 				}
  // 			});
  // 		});
  // 	}

  // 	initSliders();

  // }());

  var partnersProdBanner = function () {
    var $sliders = $('.partners-products .swiper');
    if (!$sliders.length) {
      return;
    }
    $sliders.each(function () {
      var $this = $(this);
      var $slider = new Swiper($this[0], {
        slidesPerView: 1.25,
        spaceBetween: 16,
        slidesPerGroup: 1,
        breakpoints: {
          960: {
            slidesPerView: 1.75
          },
          1200: {
            slidesPerView: 2.25
          }
        },
        scrollbar: {
          el: $this.closest('.container').find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    });
  }();
  var OverViewPosts = function () {
    var $section = $('.overview');
    if (!$section.length) {
      return;
    }
    var $layoutSelect = $section.find('.overview__layout button');
    $layoutSelect.click(function () {
      var layout = this.value;
      $layoutSelect.removeClass('active').filter($(this)).addClass('active');
      $section.removeClass('overview--compact');
      if (layout == 'compact') {
        $section.addClass('overview--compact');
      }
    });
  }();
  var FooterUSPs = function () {
    var $section = $('.footer-usps');
    if (!$section.length) {
      return;
    }
    var swiper = new Swiper('.footer-usps .swiper', {
      slidesPerView: 2,
      slidesPerGroup: 2,
      autoHeight: true,
      scrollbar: {
        el: '.footer-usps .swiper-scrollbar',
        draggable: true
      },
      breakpoints: {
        960: {
          slidesPerView: 4
        }
      }
    });
  }();
  var blogLoadMore = function () {
    var $section = $('section.blog');
    if (!$section.length) {
      return;
    }
    var $loop = $section.find('.blog__loop');
    var $pagination = $section.find('.pagination');
    $section.on('click', '.load-more', function (e) {
      e.preventDefault();
      $section.addClass('loading');
      var url = $(this).attr('href');
      $.ajax({
        url: url,
        type: "GET",
        success: function success(res) {
          console.log($(res).find('#blog-loop'));
          $loop.append($(res).find('#blog-loop').html());
          // $section.find('.pagination').remove();
          if ($(res).find('#pagination').length) {
            $pagination.html($(res).find('#pagination').html());
          } else {
            $pagination.remove();
          }
          $section.removeClass('loading');
        },
        error: function error(res) {
          console.log(res);
        }
      });
    });
  }();
  var articleFeaturedProducts = function () {
    var $article = $('article.article');
    if (!$article.length) {
      return;
    }
    var $featured = $('.article__featured-products .swiper');
    if ($featured.length) {
      console.log($featured[0]);
      var $featSwiper = new Swiper($featured[0], {
        slidesPerView: 1.25,
        spaceBetween: 16,
        breakpoints: {
          500: {
            slidesPerView: 1.5
          },
          960: {
            slidesPerView: 2
          }
        },
        scrollbar: {
          el: $featured.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    }
  }();
  var latestSlider = function () {
    var $latest = $('.latest-posts__loop .swiper');
    if (!$latest.length) {
      return;
    }
    var $featSwiper = new Swiper($latest[0], {
      slidesPerView: 1.25,
      spaceBetween: 16,
      breakpoints: {
        500: {
          slidesPerView: 1.5
        },
        960: {
          slidesPerView: 3
        }
      },
      scrollbar: {
        el: $latest.find('.swiper-scrollbar')[0],
        draggable: true
      }
    });
  }();
  var ProductSlider = function () {
    var $section = $('.product-slider');
    if (!$section.length) {
      return;
    }
    $section.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this[0], {
        slidesPerView: 1,
        centeredSlides: true,
        loop: true,
        spaceBetween: 16,
        slidesPerGroup: 1,
        breakpoints: {
          960: {
            centeredSlides: false,
            slidesPerGroup: 4,
            slidesPerView: 4
          }
        },
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        }
      });
    });
  }();
  var personalizeWidget = function () {
    var $section = $('.personalize-wid');
    if (!$section.length) {
      return;
    }
    var $imagePreview = $('.personalize-wid__image img');
    var $textInput = $('#engraving');
    var $textMirror = $('.personalize-wid__image__text');
    var $fontStyle = $('#style');
    var $materials = $('[name="material"]');
    $materials.change(function () {
      var color = $materials.filter(':checked').data('color');
      var material = $materials.filter(':checked').attr('id');
      $imagePreview.attr('src', material);
      $imagePreview.attr('srcset', material);
      $textMirror.css('color', color);
    });
    $fontStyle.on('change', function () {
      $textMirror.attr('data-font', $fontStyle.find('option:selected').text());
      $textMirror.css('font-family', $fontStyle.val());
    });
    $textInput.on('keyup', function () {
      $textMirror.text($textInput.val());
    });
  }();
  var fiftyFiftySliders = function () {
    var $section = $('.fifty-fifty--slider');
    if (!$section.length) {
      return;
    }
    var $sliders = $section.find('.main-swiper');
    $sliders.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this[0], {
        slidesPerView: 1,
        spaceBetween: 16,
        scrollbar: {
          el: $this.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $this.find('.swiper-button-next')[0],
          prevEl: $this.find('.swiper-button-prev')[0]
        }
      });
    });
    var $gallerysliders = $section.find('.mini-swiper');
    $gallerysliders.each(function () {
      var $this = $(this);
      var swiper = new Swiper($this[0], {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 3000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        },
        pagination: {
          el: $this.find('.swiper-pagination')[0],
          type: 'bullets',
          clickable: true
        }
      });
    });
  }();
  var customerAPI = function () {
    var $section = $('.my-col');
    if (!$section.length) {
      return;
    }
    var $dashButtons = $('.acc-dash [data-tab]');
    var $dashTabs = $('.acc-dash__tab');
    var $form = $section.find('form');
    var userid = $form.find('[name="userid"]').val();
    // var userid = 8038234292543;

    var $loop = $section.find('.my-col__products__loop');
    var lang = 'en';
    if (langCode != '') {
      lang = langCode;
    }
    console.log(lang);
    var errors = {
      'watchNotFound': {
        'en': "Watch not found. If the watch you're looking for isn't found, please contact us at info@norqain.com for support.",
        'de': "Uhr nicht gefunden. Wenn die gesuchte Uhr nicht gefunden wurde, kontaktiere uns bitte unter info@norqain.com für Unterstützung.",
        'fr': "Montre introuvable. Si la montre que tu cherches n'est pas trouvée, contacte-nous à info@norqain.com pour obtenir de l'aide.",
        'ja': "",
        'it': "Orologio non trovato. Se l'orologio che stai cercando non è stato trovato, contattaci all'indirizzo info@norqain.com per supporto."
      },
      'noSaleRecorded': {
        'en': "No sale has been recorded yet. If you've made a purchase, reach out to us at info@norqain.com for assistance.",
        'de': "Noch keine Verkaufsaufzeichnung. Wenn du einen Kauf getätigt hast, erreich uns unter info@norqain.com für Unterstützung.",
        'fr': "Aucune vente n'a encore été enregistrée. Si tu as effectué un achat, contacte-nous à info@norqain.com pour obtenir de l'assistance.",
        'ja': "",
        'it': "Nessuna vendita registrata ancora. Se hai effettuato un acquisto, contattaci all'indirizzo info@norqain.com per assistenza."
      },
      'alreadyActivated': {
        'en': "This product has already been activated. For any inquiries, email us at info@norqain.com for support.",
        'de': "Diese Uhr wurde bereits aktiviert. Bei Fragen sende uns eine E-Mail an info@norqain.com für Unterstützung.",
        'fr': "Cette montre a déjà été activé. Pour toute question, envoie-nous un e-mail à info@norqain.com pour obtenir de l'assistance.",
        'ja': "",
        'it': "Questo prodotto è già stato attivato. Per eventuali domande, inviaci una e-mail a info@norqain.com per supporto."
      }
    };
    var notifications = {
      'noWatches': {
        'en': "You have not registered any watches yet.",
        'de': "Du hast noch keine Uhren registriert.",
        'fr': "Tu n'as pas encore enregistré de montres.",
        'ja': "",
        'it': "Non hai ancora registrato alcun orologio."
      },
      'shopWatches': {
        'en': "Shop Watches",
        'de': "Uhren kaufen",
        'fr': "Acheter une montre",
        'ja': "",
        'it': "Comprare orologi"
      },
      'registerAnother': {
        'en': "Register Another Watch",
        'de': "Andere Uhr registrieren",
        'fr': "Enregistrer une autre montre",
        'ja': "",
        'it': "Registra un altro orologio"
      },
      'validUntil': {
        'en': "Warranty valid until",
        'de': "Garantie gültig bis",
        'fr': "Garantie valable jusqu'à",
        'ja': "",
        'it': "Garanzia valida fino a"
      }
    };
    if (urlParams.get('tab').length) {
      var tabParam = urlParams.get('tab');
      $dashButtons.removeClass('active');
      $dashButtons.filter('[data-tab="' + tabParam + '"]').addClass('active');
      $dashTabs.removeClass('active');
      $dashTabs.filter('[data-tab="' + tabParam + '"]').addClass('active');
    }

    // console.log(userid);

    function getWatches() {
      $loop.empty().addClass('loading');
      $.ajax({
        url: 'https://api.norqain.com/shopify/getWatches.php',
        type: "POST",
        data: {
          userid: userid
        },
        success: function success(res) {
          console.log(res);
          res = JSON.parse(res);
          if (Object.keys(res)) {
            if (res.hasOwnProperty('watches')) {
              buildWatches(res.watches);
            } else {
              console.log('No watches in response');
              handleNoWatches();
            }
          } else {
            console.log('Empty response');
            handleNoWatches();
          }
          $loop.removeClass('loading');
        },
        error: function error(res) {
          // console.clear();
          console.log('error');
          console.log(res);
        }
      });
    }
    getWatches();
    $form.submit(function (e) {
      e.preventDefault();
      $form.addClass('loading');
      var $errors = $('.my-col__help .form__message--error');
      var $success = $('.my-col__help .form__message--success');
      $.ajax({
        url: 'https://api.norqain.com/shopify/registerWatch.php',
        type: "POST",
        data: $form.serialize(),
        success: function success(res) {
          console.log('success');
          var res = JSON.parse(res);
          console.log(res);
          var message = res.message;
          if (res.success == false) {
            $errors.css('display', 'flex');
            var error = errors[message][lang];
            $errors.find('.form-error').text(error);
          } else {
            $errors.hide();
            $form.hide();
            $success.css('display', 'flex');
            $form.after('<a href="/account?tab=my-collection" class="btn">' + notifications['registerAnother'][lang] + '</a>');
            getWatches();
          }
          $form.removeClass('loading');
        },
        error: function error(res) {
          // console.clear();
          console.log('error');
          console.log(res);
        }
      });
    });
    function handleNoWatches() {
      $loop.html('<div class="no-results"><p>' + notifications['noWatches'][lang] + '</p><a href="/collections/all/" class="btn">' + notifications['shopWatches'][lang] + '</a></div>');
    }
    function buildWatches(watches) {
      var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      $.each(watches, function () {
        var watch = $(this)[0];
        console.log(watch);
        if (watch.ctWatchesShopifyHandle) {
          var handle = watch.ctWatchesShopifyHandle;
          var sku = '';
          var warranty = '';
          if (watch.hasOwnProperty('variation')) {
            if (watch.variation.hasOwnProperty('shopifySKU')) {
              sku = watch.variation.shopifySKU;
            }
          }
          if (watch.hasOwnProperty('warrantyEndDate')) {
            warranty = new Date(watch.warrantyEndDate);
            warranty = monthNames[warranty.getMonth()] + ' ' + warranty.getDate() + ', ' + warranty.getFullYear();
          }
          var url = window.Shopify.routes.root + 'products/' + handle + '.js';
          $.ajax({
            url: url,
            type: "GET",
            async: false,
            success: function success(res) {
              res = JSON.parse(res);
              console.log(res);
              var productHTML = '<div class="prod-card"><a href="{{product.url}}"><img src="{{product.img}}"/></a>{{product.sku}}<h3 class="h5"><a href="{{product.url}}">{{product.title}}</a></h3>{{product.warranty}}<button class="reset" data-serial="{{product.serial}}"><div class="svg-icon svg-icon--cross"><div class="positioner"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12"><path fill="none" stroke="#ccc" stroke-miterlimit="50" stroke-width="1" d="M.5 5.942h12.115"></path><path fill="none" stroke="#ccc" stroke-miterlimit="50" stroke-width="1" d="M6.558-.115V12"></path></svg></div></div></button></div>';
              productHTML = productHTML.replace("{{product.url}}", res.url);
              productHTML = productHTML.replace("{{product.url}}", res.url);
              productHTML = productHTML.replace("{{product.img}}", res.featured_image);
              productHTML = productHTML.replace("{{product.title}}", res.title);
              productHTML = productHTML.replace("{{product.serial}}", watch.serial_number);
              if (res.variants && sku != '') {
                var found = false;
                $.each(res.variants, function () {
                  var variant = $(this)[0];
                  // console.log(variant);
                  if (variant.sku == sku) {
                    found = true;
                    productHTML = productHTML.replace(res.featured_image, variant.featured_image.src);
                    productHTML = productHTML.replace("{{product.sku}}", '<span class="sku">' + variant.sku + '</span>');
                  }
                });
                if (found == false) {
                  productHTML = productHTML.replace("{{product.sku}}", '<span class="sku">' + res.variants[0].sku + '</span>');
                }
              } else {
                productHTML = productHTML.replace("{{product.sku}}", '<span class="sku">' + res.variants[0].sku + '</span>');
              }
              if (warranty != '') {
                productHTML = productHTML.replace("{{product.warranty}}", '<span class="warranty">' + notifications['validUntil'][lang] + ': ' + warranty + '</span>');
              } else {
                productHTML = productHTML.replace("{{product.warranty}}", '');
              }
              $loop.append(productHTML);
            },
            error: function error(res) {
              console.log('error, watch not found? - ' + handle);
              console.log(res);
            }
          });
        } else {
          console.log('No watch handle provided');
        }
      });
    }
    $loop.on('click', 'button', function () {
      var $this = $(this);
      var serial = $this.data('serial');
      $loop.addClass('loading');
      $.ajax({
        url: 'https://api.norqain.com/shopify/unregisterWatch.php',
        type: "POST",
        data: {
          userid: userid,
          serial: serial
        },
        success: function success(res) {
          console.log(res);
          getWatches();
        },
        error: function error(res) {
          // console.clear();
          console.log('error');
          console.log(res);
          $loop.removeClass('loading');
        }
      });
    });

    // $.ajax({
    // 	url: 'https://api.norqain.com/shopify/checkRegistration.php',
    // 	type: "POST",
    // 	data: {
    // 		serial: '22903',
    // 	},
    // 	success: function(res){
    // 		console.clear();
    // 		console.log('success');
    // 		console.log(JSON.parse(res));
    // 	},
    // 	error: function(res){
    // 		console.clear();
    // 		console.log('error');
    // 		console.log(res);
    // 	}
    // });
  }();
  var siteSearch = function () {
    var $search = $('.site-search');
    var $searchForm = $('.site-search__bar form');
    var $searchBox = $('.site-search__bar input#search');
    var $searchResults = $('.site-search__results');
    var $searchIcon = $('.menu-icon--search');
    var $searchClose = $('.close-search');
    $searchClose.click(function () {
      $search.toggleClass('active');
    });
    $searchIcon.click(function () {
      $search.toggleClass('active');
    });
    function ajaxSearch(terms) {
      console.log('search initiated');
      $.ajax({
        url: '/search/suggest',
        type: "GET",
        data: {
          q: terms,
          section_id: 'header',
          // resources[type]: 'query,product,collection,page,article',
          'resources[type]': 'query,product,page,article'
        },
        success: function success(res) {
          // console.log('success');
          // console.log(res);
          $searchResults.html($(res).find('#predictive-search-results').html());
          $searchResults.addClass('active');
        },
        error: function error(res) {
          console.log(res);
        }
      });
    }
    $('body').on('click', '.site-search__suggestion button', function () {
      var val = $(this).text();
      $searchBox.val(val);
      $searchForm.trigger('submit');
    });
    $searchForm.submit(function (e) {
      e.preventDefault();
      ajaxSearch($searchBox.val());
    });
    $searchBox.keyup(function () {
      ajaxSearch($searchBox.val());
    });
  }();
  var galleryPopup = function () {
    var $lightbox = $('.image-popup');
    if (!$lightbox.length) {
      return;
    }
    var $zoom = $('.image-zoom');
    var $slider = $('.image-popup .swiper');
    var $productGallery = $('.product-gallery .swiper');
    if ($(window).width() < 767) {
      var swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        draggable: false,
        allowTouchMove: false,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        }
      });
    } else {
      var swiper = new Swiper($slider[0], {
        slidesPerView: 1,
        loop: true,
        spaceBetween: 0,
        scrollbar: {
          el: $slider.find('.swiper-scrollbar')[0],
          draggable: true
        },
        navigation: {
          nextEl: $slider.find('.swiper-button-next')[0],
          prevEl: $slider.find('.swiper-button-prev')[0]
        }
      });
    }
    var mainSwiper = $productGallery[0].swiper;
    // LazyLoading.refresh();

    $zoom.click(function () {
      var currentSlide = mainSwiper.activeIndex;
      swiper.slideTo(currentSlide, 0);
      $lightbox.addClass('active');
    });
  }();
  var productEngraving = function () {
    var $section = $('.pdm-engrave');
    if (!$section.length) {
      return;
    }
    var $input = $section.find('.pdm-engrave__engraving');
    var $preview = $section.find('.pdm-engrave__image__text');
    var $previewSVG = $section.find('.pdm-engrave__image__text svg');
    var $previewText = $section.find('.pdm-engrave__image__text text');
    var $fonts = $section.find('[name="pdm-engrave__font-option"]');
    var $fee = $section.find('[name="pdm-engrave__fee"]');
    var $freFee = $section.find('[name="pdm-engrave__free_fee"]');
    var $fontProp = $('.pdm-engrave__font');
    $fonts.change(function () {
      var $selectedFont = $fonts.filter(':checked');
      $preview.attr('data-font', $selectedFont.val());
      $previewSVG.removeClass().addClass('font--' + $selectedFont.val().replace(/\s+/g, '-').toLowerCase());
      $fontProp.val($selectedFont.val());
    });
    $input.on('keyup', function () {
      console.log($fee, $freFee);
      var val = $(this).val();
      $previewText.text(val);
      // console.log(val);
      if (val.length) {
        $section.addClass('active');
        $input.attr('name', 'properties[Engraving]');
        $fontProp.attr('name', 'properties[Engraving Font]');
        $fee.attr('name', 'properties[Engraving Fee]');
        $freFee.attr('name', 'properties[_engravingFreeFee]');
        var words = val.split(' ');
        var output = '';
        var line = '';
        for (var i = 0; i < words.length; i++) {
          var word = words[i];
          if (line.length + word.length + 1 <= 14) {
            line += word + ' ';
          } else {
            output += line.trim() + '<br>';
            line = word + ' ';
          }
        }
        output += line.trim();
        console.log(output);
      } else {
        // $section.removeClass('active');
        $input.removeAttr('name');
        $fontProp.removeAttr('name');
        $fee.removeAttr('name');
        $freFee.removeAttr('name');
      }
    });
    $fonts.trigger('change');
  }();
  var zoom = function () {
    var $zoom = $('.zoom');
    if (!$zoom.length) {
      return;
    }
    $zoom.each(function () {
      var $this = $(this);
      var $parent = $this.closest('.product-image');
      var url = $parent.data('master');
      var magnify = $parent.data('zoom-level') ? $parent.data('zoom-level') : 1.2;
      $this.zoom({
        url: url,
        magnify: magnify
      });
    });

    // $('.zoom img').wrap('<span style="display:inline-block"></span>').css('display', 'block').parent().zoom();
  }();
});